import { Box, Typography } from "@mui/material";

export default function InfoSection({ titulo, items, rodape, heightBox = null }: InfoSectionProps) {
    return (
        <Box height="100%">
            <Box p={1} bgcolor="#1b5e20" width="100%" borderRadius="4px 4px 0 0">
                <Typography color="white" fontWeight="bold" variant="subtitle2">{titulo}</Typography>
            </Box>

            <Box p={1.5} px={2} border="1px solid #ccc" borderRadius="0 0 4px 4px" height={heightBox ?? "unset"}>
                {
                    items.map(({ section }, index) => (
                        <Box
                            key={index}
                            py={1}
                            borderTop={(items.length > 1 && index > 0) ? "1px solid #ccc" : "unset"}
                        >
                            {
                                section.map(({ label, valor, variant }) => (
                                    <Box display="flex" py={0.3} justifyContent="space-between" alignItems="center">
                                        <Typography variant={variant ?? "caption"} fontWeight={variant === "subtitle1" ? "bold" : "normal"}>{label}:</Typography>
                                        <Typography fontWeight="bold" variant={variant ?? "caption"}>{valor}</Typography>
                                    </Box>
                                ))
                            }
                        </Box>
                    ))
                }
                {
                    rodape &&
                    <Box display="flex" py={1.5} justifyContent="space-between" alignItems="center" borderTop="1px solid #ccc">
                        <Typography fontWeight="bold" variant="subtitle1">{rodape.label}:</Typography>
                        <Typography fontWeight="bold" variant="subtitle1">{rodape.valor}</Typography>
                    </Box>
                }
            </Box>
        </Box>
    )
}

interface InfoSectionProps {
    titulo: string,
    items: Array<{
        section: TInfoSectionItems[]
    }>,
    rodape?: TInfoSectionItems
    heightBox?: string | null
}

type TInfoSectionItems = {
    label: string,
    valor: string | number,
    variant?: "caption" | "subtitle1"
}